export enum QuotesTableAccessor {
  ContactId = 'contactId',
  Description = 'description',
  DocumentType = 'documentType',
  DueDate = 'dueDate',
  IssueDate = 'issueDate',
  NetTotal = 'netTotal',
  QuoteNumber = 'invoiceNo',
  Status = 'status',
}
